import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import styled from 'styled-components';
import 'isomorphic-fetch';

import ERROR_BOUNDARY_TRANSLATIONS_QUERY from './errorBoundary/errorBoundaryTranslations.query.graphql';

import {
  withApplicationQuery,
  ApplicationQueryContext,
} from '../../graphql/components/ApplicationQueryProvider';

import {
  Box,
  Button,
  ThemeProvider,
  VerticalSpacing,
} from '../../components/Boneyard';

import Markdown from '../../components/Markdown';

import { getLoggingUri } from '../../utils/routeUtils';
import { extractTokens } from '../../utils/authUtils';

const Paragraph = styled.p`
  max-width: 500px;
`;

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    hasError: false,
  };

  componentDidCatch(error) {
    // Don't send errors to logging service in test env
    if (process.env.NODE_ENV === 'test') {
      console.error(error);
    } else {
      const loggingUri = getLoggingUri();
      const { authToken, ...tokens } = extractTokens();

      fetch(loggingUri, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({ error: error.stack, data: tokens }),
      });
    }
    this.setState({ hasError: true });
  }

  navigateToRoot() {
    Router.push('/');
  }

  render() {
    if (this.state.hasError) {
      return (
        <ApplicationQueryContext.Consumer>
          {application => {
            const {
              errorBoundaryTitle,
              errorBoundaryMessage,
              errorBoundaryContinueButtonLabel,
            } = application?.translations.errors || {};

            return (
              <ThemeProvider>
                <Box>
                  <Box d="flex" alignItems="center" direction="column">
                    <h1>
                      <Markdown
                        source={errorBoundaryTitle}
                        data={{ ellipsis: '&hellip;' }}
                      />
                    </h1>
                    <Paragraph>{errorBoundaryMessage}</Paragraph>
                    <VerticalSpacing size={4} />
                    <Button onClick={this.navigateToRoot}>
                      {errorBoundaryContinueButtonLabel}
                    </Button>
                  </Box>
                </Box>
              </ThemeProvider>
            );
          }}
        </ApplicationQueryContext.Consumer>
      );
    }

    return this.props.children;
  }
}

export default withApplicationQuery(
  ERROR_BOUNDARY_TRANSLATIONS_QUERY,
  ErrorBoundary
);
